<template>
  <v-container class="fill-height eservice_type" fluid>
    <v-layout class="eservice_inner_wrap login_wrap type2">
      <v-flex class="pa-0 login_content type2">
        <v-form
          v-model="valid"
          lazy-validation
        >
          <v-card class="login_form type2 type3" flat>
            <h2 class="logo mb-25"><v-img src="~@/assets/img/logo_auth.png" alt="EGPO" @click="$router.push('/main')" style="cursor:pointer;"></v-img></h2>
            <h3 class="out_title mb-15">{{ $t('signin.set_password.title') }}</h3>

            <v-card
              flat
              class="foot__info type2 mb-40"
            >
              <v-card-text class="pa-0">
                <h2>{{ $t('signin.set_password.fields.password_rule_title') }}</h2>
                <div class="d-flex">
                  <v-spacer class="hidden_lr10 d-inline-block"></v-spacer>
                  <p class="d-inline-block">{{ $t('signin.set_password.fields.password_rule_1') }}</p>
                </div>
                <div class="d-flex">
                  <v-spacer class="hidden_lr10 d-inline-block"></v-spacer>
                  <p class="d-inline-block">{{ $t('signin.set_password.fields.password_rule_2') }}</p>
                </div>
              </v-card-text>
            </v-card>

            <v-card-text class="pa-0 inner_item_content mb-30">
              <v-row class="ma-0">
                <v-col cols="12" class="pa-0 mb-0">
                  <h2 class="nec_title mb-15">{{ $t('signin.set_password.fields.password') }}</h2>
                  <v-text-field
                      label=""
                      solo
                      outlined
                      flat
                      dense
                      append-icon="mdi-alert"
                      type="password"
                      class="login_text_filed"
                      v-model="new_password"
                      v-validate="{required: true, password_rule: true}"
                      :error-messages="errors.collect('new_password')"
                      name="new_password"
                      :data-vv-as="$t('signin.set_password.fields.password')"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" class="pa-0">
                  <p style="font-size: 10px; color : #a01c2a; padding-left: 7px; line-height : 14px;" class="mt--5" >{{$t('signup.agent.regist.fields.password_rull2') }}</p>
                </v-col>

                <v-col cols="12" class="pa-0 mb-35">
                  <h2 class="nec_title mb-15">{{ $t('signin.set_password.fields.password_re') }}</h2>
                  <v-text-field
                      label=""
                      solo
                      outlined
                      flat
                      dense
                      append-icon="mdi-alert"
                      type="password"
                      class="login_text_filed"
                      v-model="verify_password"
                      v-validate="{required: true, password_match: true}"
                      :error-messages="errors.collect('verify_password')"
                      name="verify_password"
                      :data-vv-as="$t('signin.set_password.fields.password_re')"
                  ></v-text-field>
                </v-col>

                <!-- Two-Factor Auth -->
                <h3 class="alert_text_title pb-5">{{ $t('signup.agent.regist.fields.select_method_notice') }}</h3>
                <v-col cols="12" class="pa-0 mb-50">
                  <h2 class="nec_title mb-15">{{ $t('signin.set_password.fields.two_factor') }}</h2>
                  <v-select
                    hide-details
                    solo
                    flat
                    outlined
                    dense
                    class="select_h40 login_select_box bdr_none"
                    :items="$vuetify.rtl ? methodListAr : methodListEn"
                    v-model="strong_auth_type_code"
                  ></v-select>
                </v-col>

                <!-- Google OTP -->
                <h3 class="alert_text_title pb-5" v-show="strong_auth_type_code == '3703'">{{ $t('signup.agent.regist.fields.google_otp_notice') }}</h3>
                <v-col cols="12" class="pa-0 mb-30" v-show="strong_auth_type_code == '3703'">
                  <v-col cols="12" class="pa-0 mb-30">
                    <div class="otp_box">
                      <v-img :src="qrcode_url"></v-img>
                    </div>
                  </v-col>
                  <v-col cols="12" class="pa-0">
                    <h2 class="nec_title mb-15">{{ $t('signin.set_password.fields.otp_code') }}</h2>
                    <v-text-field
                        label=""
                        solo
                        outlined
                        flat
                        dense
                        append-icon="mdi-alert"
                        type="password"
                        class="login_text_filed"
                        v-model="otp_code"
                        v-validate="{required: valid_google, pincode_rule: valid_google}"
                        :error-messages="errors.collect('otp_code')"
                        name="otp_code"
                        :data-vv-as="$t('signin.set_password.fields.otp_code')"
                    ></v-text-field>
                  </v-col>
                </v-col>

                <!-- PIN CODE -->
                <h3 class="alert_text_title pb-5" v-show="strong_auth_type_code == '3702'">{{ $t('signup.agent.regist.fields.pin_code_notice') }}</h3>
                <v-col cols="12" class="pa-0 mb-30" v-show="strong_auth_type_code == '3702'">
                  <v-col cols="12" class="pa-0 mb-30">
                    <h2 class="nec_title mb-15">{{ $t('signin.set_password.fields.pin_code') }}</h2>
                    <v-text-field
                        label=""
                        solo
                        outlined
                        flat
                        dense
                        append-icon="mdi-alert"
                        type="password"
                        class="login_text_filed"
                        v-model="registered_pin_code"
                        v-validate="{required: valid_pincode, pincode_rule: valid_pincode}"
                        :error-messages="errors.collect('registered_pin_code')"
                        name="registered_pin_code"
                        :data-vv-as="$t('signin.set_password.fields.pin_code')"
                        maxlength="6"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" class="pa-0">
                    <h2 class="nec_title mb-15">{{ $t('signin.set_password.fields.pin_code_re') }}</h2>
                    <v-text-field
                        label=""
                        solo
                        outlined
                        flat
                        dense
                        append-icon="mdi-alert"
                        type="password"
                        class="login_text_filed"
                        v-model="registered_pin_code_re"
                        v-validate="{required: valid_pincode, pincode_match: valid_pincode}"
                        :error-messages="errors.collect('registered_pin_code_re')"
                        name="registered_pin_code_re"
                        :data-vv-as="$t('signin.set_password.fields.pin_code_re')"
                        maxlength="6"
                    ></v-text-field>
                  </v-col>
                </v-col>


              </v-row>
            </v-card-text>

            <v-row class="ma-0 btn_wrap pb-50">
              <v-btn class="sign_in_btn type2 colorwh" text @click="fnSave()">{{ $t('common.button.save') }}</v-btn>
            </v-row>
          </v-card>

        </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import requestApi from '@/utils/requestApi'
import utils from '@/utils/utils'
import eventBus from '@/utils/eventBus'

export default {
  name: 'SetPassword',
  components: {
  },
  data () {
    return {

      methodListAr : [],
      methodListEn : [],

      valid :true,
      valid_google : false,
      valid_pincode : false,

      email_verify_hash_value: '',
      email: '',
      new_password: '',
      verify_password: '',

      //2차인증 방식
      strong_auth_type_code : '',
      registered_pin_code : '',
      registered_pin_code_re : '',

      //Google Otp 관련
      qrcode_url : '',
      encode_key : '',
      otp_code : '',

    }
  },
  created () {
    this.$validator.extend('password_rule',{
      getMessage: field => field+' is not meet the required security level',
      validate: value => {
        //소문자 대문자 숫자 (8,32)
        let check_1 = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d]{8,32}/.test(value)

        //소문자 대문자 특수문자 (8,32)
        let check_2 = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&+=])[A-Za-z!@#$%^&+=]{8,32}/.test(value)

        //소문자 숫자 특수문자 (8,32)
        let check_3 = /^(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&+=])[a-z\d!@#$%^&+=]{8,32}/.test(value)

        //대문자 숫자 특수문자 (8,32)
        let check_4 = /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&+=])[A-Z\d!@#$%^&+=]{8,32}/.test(value)

        //소문자 대문자 숫자 특수문자(8,32)
        let check_5 = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&+=])[A-Za-z\d!@#$%^&+=]{8,32}/.test(value)

        let result = false
        if(check_1 || check_2 || check_3 || check_4 || check_5){
          result = true
        }

        return result
      }
    })

    this.$validator.extend('password_match', {
      getMessage: field => field+' is not matched',
      validate: value => {

        let target = this.$validator.fields.find({name: 'new_password'})

        return value == target.value

      }
    })

    this.$validator.extend('pincode_rule',{
      getMessage: field => field+' must be 6 Decimal digit numbers',
      validate: value => {
        //숫자(6)
        let check = /^\d{6}$/.test(value)

        if(check){
          this.pinCodeNotMatche = false
        }else{
          this.pinCodeNotMatche = true
        }

        return check
      }
    })

    this.$validator.extend('pincode_match', {
      getMessage: field => field+' is not matched',
      validate: value => {

        let target = this.$validator.fields.find({name: 'registered_pin_code'})

        return value == target.value

      }
    })

  },
  watch: {
    new_password() {
      this.$validator.validate('verify_password')
    },

    registered_pin_code() {
      this.$validator.validate('registered_pin_code_re')
    },

    strong_auth_type_code() {
      if(this.strong_auth_type_code === '3702'){
        this.valid_google = false
        this.valid_pincode = true
      }else if(this.strong_auth_type_code === '3703'){
        this.valid_google = true
        this.valid_pincode = false
      } else if (this.strong_auth_type_code === '3704') {
        this.valid_google = false
        this.valid_pincode = false
      }
    }
  },
  mounted () {
    window.scrollTo(0, 0)
    this.fnInit()
  },
  methods: {
    fnInit() {
      //url에서 마지막 단을 코드값으로 담아두자
      let codeParamArr = window.location.href.split("/")
      this.email_verify_hash_value = codeParamArr[codeParamArr.length - 1]

      //추출한 코드가 유효한 값인지 확인 하고 유효 하지 않을 경우 돌려보낸다
      requestApi({
        url: '/autho/verify/setpassword/'+this.email_verify_hash_value,
        method: 'GET',
        callback: (res) => {

          if(res.res_code == '200'){
            this.email = res.data.user_email

            this.fnGetTwoFactorMethodList()
            this.fnGetQrCode()
          }else{
            eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            this.$router.push({ path : '/signin' })
          }
        }
      })

    },

    fnGetTwoFactorMethodList() {
      let options = {
        upper_code: '3700',
        remove: [
          {code: '3701'}
        ]
      }
      utils.fnGetCodeList(options).then(list => {
        this.methodListAr = list.ar
        this.methodListEn = list.en

        if(this.methodListAr.length > 0){
          this.strong_auth_type_code = this.methodListAr[0].value
        }
      })
    },

    fnGetQrCode(){
      //Google OTP QR Code URL및 인증키
      let params = {
        email : this.email
      }

      requestApi({
        url: '/autho/googleotp/qrcode',
        method: 'POST',
        data: params,
        callback: (res) => {
          if (res.res_code === '200') {
            this.qrcode_url = res.data.qrcode_url
            this.encode_key = res.data.encode_key
          } else {
            eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
          }
        }
      })
    },

    fnChangePassword(){
      let params = {
        email_verify_hash_value : this.email_verify_hash_value,
        email : this.email,
        new_password : this.new_password,
        verify_password : this.verify_password
      }
      return new Promise(function(resolve, reject){
        requestApi({
          url: '/autho/setpassword',
          method: 'PUT',
          data: params,
          callback: (res) => {
            if (res.res_code === '200') {
              resolve()
            } else {
              reject(res)
            }
          }
        })
      })
    },

    fnChangeTwoFactor(){
      let params = {
        email_verify_hash_value : this.email_verify_hash_value,
        email : this.email,
        strong_auth_type_code : this.strong_auth_type_code
      }

      if(this.strong_auth_type_code == '3702'){
        //PIN CODE 라면
        params.pin_code = this.registered_pin_code

      }else if(this.strong_auth_type_code == '3703'){
        //Google OTP 라면
        params.pin_code = this.encode_key
        params.otp_code = this.otp_code
      }

      requestApi({
        url: '/autho/setstrongauth',
        method: 'PUT',
        data: params,
        callback: (res) => {
          if (res.res_code === '200') {
            let option = {
              text : this.$t('common.message.add.success')
            }
            eventBus.$emit('SHOW_SNACKBAR', option)
            this.$router.push('/signin')

          } else {
            eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
          }
        }
      })

    },

    fnSave(){
      this.$validator.validateAll().then((result) => {
        if(result){
          this.fnChangePassword().then( () => {
            this.fnChangeTwoFactor()
          }).catch(res => {
            eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
          })
        }
      })
    },

  }

}
</script>

<style lang="less">
</style>
